import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedCompany: "",
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setCompany: (state, action) => {
      state.selectedCompany = action.payload;
    },
  },
});

export const { setCompany } = dashboardSlice.actions;

export default dashboardSlice.reducer;
